import pageContext from 'salvo-lite/context'
import Slider from './components/Slider'
import Wow from './components/Wow'
import Meganav from './components/Meganav'
import AjaxCart from './components/AjaxCart'
import CartUpdateTotal from './components/CartUpdateTotal'
import CurrencyConverterMod from './components/CurrencyConverterMod'
import InfiniteScroll from './components/InfiniteScroll'
import CollectionFilters from './components/CollectionFilters'
import VariantDropdowns from './components/VariantDropdowns'
// import ShopifyLinkedOptions from './components/ShopifyLinkedOptions'
import ProductInfoTabs from './components/ProductInfoTabs'
import Zoom from './components/Zoom'
import Checkout from './components/Checkout'
import Tooltips from './components/Tooltips'
import ReadMore from './components/ReadMore'
import Variants from './components/Variants'

const components = {
    'slider': Slider,
    'wow': Wow,
    'meganav': Meganav,
    'ajax-cart': AjaxCart,
    'cart-update-total': CartUpdateTotal,
    'currency-switcher': CurrencyConverterMod,
    'infinite-scroll': InfiniteScroll,
    'tag-filter': CollectionFilters,
    'variant-dropdowns': VariantDropdowns,
    // 'linked-options': ShopifyLinkedOptions,
    'js-tabs': ProductInfoTabs,
    'drift-zoom': Zoom,
    'customer-information-form': Checkout,
    'pseudo-swatches': Tooltips,
    'read-more': ReadMore,
    'variants': Variants
}

const pages = {
}

class Theme {
    constructor () {
        this._components = []
        this._componentsById = {}
    }

    registerComponents (container = document) {
        for (let key in components) {
            var ComponentConstructor = components[key]
            var elements = container.querySelectorAll(`.js-component__${key}, [data-${key}]`)
            for (let elem of elements) {
                var instance = new ComponentConstructor(this, elem)
                this._components.push(instance)
                var id = elem.dataset.componentId
                if (id) {
                    this._componentsById[id] = instance
                }
                instance.onInit()
            }
        }
        window.ThemeComponents = this._components
        window.ThemeComponentsId = this._componentsById
        window.__Theme = this
    }

    registerPages () {
        var context = pageContext.getTemplate()
        for (let page in pages) {
            if (page === context) {
                var instance = new pages[page](this)
                instance.onInit()
            }
        }
    }

    getComponents () {
        return this._components
    }

    getComponentsById (id) {
        return this._componentsById[id]
    }

    getComponentsByType (componentConst, includeSubclasses = true) {
        var r = []
        for (let c of this._components) {
            if (includeSubclasses && c instanceof componentConst) {
                r.push(c)
            } else if (c.constructor === componentConst) {
                r.push(c)
            }
        }
        return r
    }
}

export default Theme



// WEBPACK FOOTER //
// ./src/resources/scripts/Theme.js